// Centralized Novu application identifier for the frontend
// Prefer injected global to avoid ReferenceErrors; then env; finally a safe default
export const NOVU_APP_IDENTIFIER: string = (
  (globalThis as any).PIQUE_ENV?.NOVU_APP_IDENTIFIER
  || (typeof process !== 'undefined' ? (process as any).env?.NOVU_APP_IDENTIFIER : undefined)
  || '8bozdZKhEhXV'
);
